// helper functions for building and sending invite mails and other messages

// fallback name in case the logged in user is nameless (should not happen).
const FALLBACK_SENDER_NAME = 'EBBER Selection'

type MessageTemplate = {
  body?: string
  id?: number | string
  sender_name?: string
  subject?: string
}

type MessageCandidate = {
  name?: string
  gma?: { answers?: object | null; secondsTotal?: number | null }
  quiz_url?: string
  [key: string]: unknown
}

type MessageSender = {
  first_name?: string
  last_name?: string
}

type MessageContext = Record<string, unknown>

const makeContext = (candidate: MessageCandidate): MessageContext => ({
  name: candidate.name,
  questions: Object.keys(candidate.gma?.answers ?? {}).length,
  minutes: Math.floor((candidate.gma?.secondsTotal ?? 0) / 60),
  url: candidate.quiz_url,
})

const senderName = (sender: MessageSender) => {
  const names = [sender.first_name, sender.last_name].filter(Boolean)
  return names.length ? names.join(' ') : FALLBACK_SENDER_NAME
}

export const renderMessage = ({
  template = {},
  candidate = {},
  sender = {},
  context = {},
}: {
  candidate?: MessageCandidate
  context?: MessageContext
  sender?: MessageSender
  template?: MessageTemplate
}) => ({
  sender_name: template.sender_name || senderName(sender),
  receiver_name: candidate.name ?? '',
  subject: template.subject,
  body: renderBody(template.body || '')({
    ...makeContext(candidate),
    ...context,
  }).trim(),
  templateId: template.id,
})

export const renderBody = template => context => {
  // simple template rendering
  const replacer = (match: string, group: string) =>
    (context[group] as string | undefined) || match
  return template.replace(/\{\{ *([^} ]+) *\}\}/g, replacer)
}
